<template>
  <svg
    :width="width"
    :height="height"
    class="mini-line-chart"
  >
    <path
      :d="pathData"
      :stroke="color"
      fill="none"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      v-if="safeData.length > 0"
      :cx="width - 3"
      :cy="getY(safeData[safeData.length - 1])"
      r="3"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'MiniLineChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
    width: {
      type: [Number, String],
      default: 100,
    },
    height: {
      type: [Number, String],
      default: 30,
    },
    color: {
      type: String,
      default: '#7367f0',
    },
  },
  computed: {
    numericWidth() {
      return parseInt(this.width, 10)
    },
    numericHeight() {
      return parseInt(this.height, 10)
    },
    safeData() {
      // Ensure we always have valid data
      if (!this.data || !Array.isArray(this.data) || this.data.length === 0) {
        return [0]
      }
      // Filter out invalid values
      return this.data.map(value => (Number.isNaN(Number(value)) ? 0 : Number(value)))
    },
    maxValue() {
      if (!this.safeData.length) return 1
      return Math.max(...this.safeData, 1) // Ensure we have a positive value
    },
    minValue() {
      if (!this.safeData.length) return 0
      return Math.min(...this.safeData, 0)
    },
    pathData() {
      if (!this.safeData.length) return ''

      try {
        // Calculate the path
        const points = this.safeData.map((value, index) => {
          const x = (index / (this.safeData.length - 1 || 1)) * (this.numericWidth - 6) + 3
          const y = this.getY(value)
          return `${x},${y}`
        })

        return `M ${points.join(' L ')}`
      } catch (error) {
        console.error('Error generating chart path:', error)
        return ''
      }
    },
  },
  methods: {
    getY(value) {
      try {
        // Scale the value to fit within the SVG height
        const padding = 3
        const range = Math.max(this.maxValue - this.minValue, 1)
        const scaledValue = ((value - this.minValue) / range) * (this.numericHeight - 2 * padding)

        // Invert Y axis (SVG y=0 is at the top)
        return this.numericHeight - scaledValue - padding
      } catch (error) {
        console.error('Error calculating Y coordinate:', error)
        return this.numericHeight / 2
      }
    },
  },
}
</script>

<style scoped>
.mini-line-chart {
  overflow: visible;
}
</style>
